module.exports = __webpack_public_path__ + "static/img/ba4.39bbf237.png";